export default `
<section class="seven bg-white text-center pb-3">
<div class="container">
    <h6 class="p pt-3 mb-0">++{{section12text}}</h6>
    <a href="++{{section12link}}">++{{section12linktext}}</a>
</div>
</section>
`